export enum RccapCorrectiveAction {    
    Unknown = 0,
    Screening = 1,
    DonorProfile = 2,
    DonorEval = 3,
    DonorMonitoring = 4,
    UtilizeCryo = 5,
    InsuranceClearance = 6,
    UpdatedInfo = 7,
    Medicaid = 8,
    Avoids = 9,
    ExmResponse = 10,
    CurrentInfo = 11,
    ListDsaExm = 12,
    None = 13,
    DonorReview = 14
}